module.exports = __webpack_public_path__ + "static/img/sa.17dafda3.svg";